import { render, staticRenderFns } from "./PayRecodePage.vue?vue&type=template&id=e503218e&scoped=true"
import script from "./PayRecodePage.vue?vue&type=script&lang=js"
export * from "./PayRecodePage.vue?vue&type=script&lang=js"
import style0 from "./PayRecodePage.vue?vue&type=style&index=0&id=e503218e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e503218e",
  null
  
)

export default component.exports